// Het lint "Testmodus" (rechtsboven; voluit "Testmodus - nog niet live") en het scherm "Binnenkort beschikbaar". (Mollie blok 2, 15-09-2026.)
//
// Afgesproken met Martijn: een winkel die al klaarstaat maar nog niet via Mollie kan betalen, is
// dicht voor gasten en open voor de eigenaar met zijn voorbeeldlink. Zie src/lib/testmodus.js.
import { useSyncExternalStore } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { isBinnenkort, isTestmodus, volgBinnenkort } from "../lib/testmodus";

const stand = () => (isBinnenkort() ? "binnenkort" : isTestmodus() ? "testmodus" : "gewoon");

export default function Testmodus({ children }) {
  const { t } = useTranslation();
  const nu = useSyncExternalStore(volgBinnenkort, stand, stand);
  const volledig = t("testmodus.balk", "Testmodus - nog niet live");

  if (nu === "binnenkort") {
    return (
      <Box
        role="status"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          padding: 3,
          backgroundColor: "#f5f5f5",
        }}
      >
        <Typography variant="h5" component="p" sx={{ textAlign: "center" }}>
          {t("testmodus.binnenkort", "Binnenkort beschikbaar")}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      {nu === "testmodus" && (
        // Een klein schuin lint rechtsboven in plaats van een gele balk over de hele breedte (punt 15, Martijn 11-10-2026).
        // Vast in de hoek van de widget (in een iframe is dat de hoek van het iframe), neemt geen hoogte in en vangt geen
        // klikken af (pointer-events: none), zodat knoppen eronder gewoon werken.
        <Box
          role="status"
          aria-label={volledig}
          title={volledig}
          data-jm-testlint=""
          sx={{
            position: "fixed",
            top: 0,
            right: 0,
            width: 92,
            height: 92,
            overflow: "hidden",
            pointerEvents: "none",
            zIndex: 2000,
          }}
        >
          <Box
            aria-hidden
            sx={{
              position: "absolute",
              top: 18,
              right: -30,
              width: 120,
              transform: "rotate(45deg)",
              backgroundColor: "#f59e0b",
              color: "#1f2937",
              fontWeight: 700,
              fontSize: 10,
              lineHeight: "18px",
              letterSpacing: "0.04em",
              textAlign: "center",
              textTransform: "uppercase",
              boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
              whiteSpace: "nowrap",
            }}
          >
            {t("testmodus.lint", "Testmodus")}
          </Box>
        </Box>
      )}
      {children}
    </>
  );
}

Testmodus.propTypes = {
  children: PropTypes.node,
};
